// See http://2ality.com/2015/01/es6-set-operations.html
export function intersect(left: any[], right: any[]): any[] {
    let b = new Set(right);
    return [...left].filter(x => b.has(x));
}

export function stringToArray(source: string) {
    return (source || "").split(",").filter((x: string) => !!x)
}


// WEBPACK FOOTER //
// ./src/utils.ts